"use client";

import { EventLabels } from "@/app/constants/mix-panel-enums";
import { useMixPanel } from "@/app/context/mixPanelContext";
import { useEffect, useState } from "react";

import { useTranslation } from "react-i18next";
import { Spinner } from "reactstrap";

function LandingV2() {
  const { trackEvent, mixpanelInitialized } = useMixPanel();

  const [LandingComponent, setLandingComponent] =
    useState<React.ComponentType | null>(null);
  const [error, setError] = useState<string | null>(null);
  const {
    i18n: { language },
  } = useTranslation();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const allSearchParams = Object.fromEntries(urlParams.entries());

    trackEvent(EventLabels.SL_Landing_Page, {
      screen: "Landing",
      ...allSearchParams,
    });
    trackEvent(EventLabels.SL_Landing_Page_Done, { screen: "Landing" });
  }, [mixpanelInitialized]);

  useEffect(() => {
    // import(`./client-wise/${process.env.NEXT_PUBLIC_PROJECT_CODE_ASSET}/index`)
    import(`./client-wise/${process.env.NEXT_PUBLIC_PROJECT_CODE_ASSET}/index`)
      .then((module) => {
        setLandingComponent(() => module.default);
        setError(null); // Clear any previous errors if the component loads successfully
      })
      .catch((err) => {
        console.error("Error loading component:", err);
        setError("Failed to load the component. Please try again later.");
      });
  }, [language]);
  if (error) {
    return <div className="error-message">{error}</div>;
  }

  if (!LandingComponent) {
    <div className="inital-loading-screen">
      <Spinner />
    </div>;
  } else {
    return <LandingComponent />;
  }
}

export default LandingV2;
